<template>
  <div>
    <v-container
      v-if="loaded"
      style="padding-top: 0px"
      :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''"
    >
      <v-row>
        <v-col cols="12" style="padding:8px 8px 0px 8px">
          <v-row>
            <v-col cols="8" xs="12">
              <span v-if="!myOwn" @click="routeUser()" class="pointer hover">
                <Avatar
                  v-if="user.avatar != null"
                  class="timeline-avatar"
                  :src="`https://tradeinpool.com/upload/${user.avatar}.png`"
                  :size="40"
                ></Avatar>
                <Avatar v-else class="timeline-avatar" :username="user.username" :size="40"></Avatar>
              </span>

              <span
                v-if="!myOwn"
                @click="routeToDiary"
                class="pointer subheadline mt-3 ml-12"
              >{{user.username}}'s Trading Diary</span>
              <span v-else @click="routeToDiary" class="pointer subheadline">Trading Diary</span>
              <v-icon color="rgba(128, 143, 156, 1)">keyboard_arrow_right</v-icon>
              <v-chip
                @click="routeToDiaryDate"
                class
                color="rgba(128, 143, 156, 0.2)"
                label
                outlined
              >
                <span class="date-font text-grey mr-1">Detail of</span>
                <span class="date-font text-green">{{detailDateString}}</span>
              </v-chip>
              <v-icon color="rgba(128, 143, 156, 1)">keyboard_arrow_right</v-icon>
              <v-chip class color="rgba(128, 143, 156, 0.2)" label outlined>
                <span class="date-font text-grey mr-1">Trade ID:</span>
                <span class="date-font text-green">TR{{$route.params.id}}</span>
              </v-chip>
            </v-col>
          </v-row>
        </v-col>

        <v-col xl="9" lg="9" md="9" sm="12">
          <v-card flat class="pa-0 ma-0">
            <v-row class="pa-0">
              <v-col cols="8" class="pa-1">
                <div class="chart-head pt-2 pl-6">
                  <span class="chart-title-new text-white">{{data.Symbol.user}}</span>
                  <span
                    class="ml-2 chart-title-new"
                    :class="data.OpenProfitLoss > 0 ? 'profit': (data.OpenProfitLoss < 0 ?'loss' : 'text-grey')"
                  >${{data.OpenProfitLoss.toFixed(2)}}</span>
                </div>
                <div class="pl-4">
                  <Chart
                    v-if="data.MarketData"
                    :tradeType="data.TradeType"
                    :chartData="data.MarketData"
                    :newData="data.MarketData[data.MarketData.length-1]"
                    :lastClose="data.LastPrice"
                    :fills="data.Fills"
                    :zones="zones"
                  />
                </div>
              </v-col>
              <v-col cols="4" class="pa-1 border-left">
                <div class="pl-4 pr-6">
                  <div class="chart-title-sm pt-3">Trade Note</div>
                  <div class="float-right" v-if="myOwn">
                    <v-btn
                      v-if="!data.Description || editDesc"
                      :disabled="description ? false : true"
                      @click="saveDescription"
                      x-small
                      class="white--text text-capitalize mt-2"
                      color="#79c04d"
                    >
                      SAVE
                      <v-icon size="14">note_add</v-icon>
                    </v-btn>
                    <v-btn
                      v-else
                      small
                      @click="editDescription"
                      icon
                      class="white--text text-capitalize mt-2"
                    >
                      <v-icon color="#808F9C" size="16">edit</v-icon>
                    </v-btn>
                  </div>
                  <TextInput
                    v-if="(!data.Description || editDesc) && myOwn"
                    placeholder="Trade comment..."
                    @textData="descriptionData"
                    :reset="descriptionInputReset"
                    :sending="sendingDescription"
                    :default="description"
                  />
                  <div
                    style="height: 160px;display: table;"
                    class="float-left width-full text-center"
                    v-if="!data.Description && !myOwn"
                  >
                    <div
                      style="display: table-cell; vertical-align: middle;color:#1E242E;font-size: 50px"
                    >N/A</div>
                  </div>
                  <div
                    class="width-full float-left text-font"
                    style="min-height:160px"
                    v-if="(data.Description && !editDesc)"
                  >
                    <TextSlicer :text="data.Description" :maxLength="250" />
                  </div>
                  <div class="chart-title-sm pt-3">Screenshot</div>
                  <div class="float-right">
                    <v-btn
                      v-if="mainImg"
                      small
                      @click="deleteImg"
                      icon
                      class="white--text text-capitalize mt-2"
                    >
                      <v-icon color="#808F9C" size="16">delete</v-icon>
                    </v-btn>
                  </div>
                  <v-progress-linear v-if="uploading" indeterminate value="0"></v-progress-linear>
                  <UploadBox v-if="!mainImg && myOwn" @imgData="imgDataDisplay" :exists="mainImg" />
                  <div v-else class="width-full float-left text-center pt-1">
                    <vue-picture-swipe fullWidth :items="[data._mainImg]"></vue-picture-swipe>
                  </div>
                  <div
                    style="height: 160px;display: table;"
                    class="float-left width-full text-center"
                    v-if="!mainImg && !myOwn"
                  >
                    <div
                      style="display: table-cell; vertical-align: middle;color:#1E242E;font-size: 50px"
                    >N/A</div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" class="pa-1 border-top">
                <div class="px-4">
                  <div class="width-full float-left pa-2 mb-2">
                    <span class="text-green" style="font-size:12px;">
                      <v-icon size="18" class="mr-1" color="#4dbac0">hourglass_empty</v-icon>
                      <b>Trade Prepare</b>
                      <div
                        class="pa-4 text-info width-full text-center"
                        v-if="!data._prepare"
                      >This trade has no preparation. You can tag using Post Evaluation bellow.</div>
                      <div class="pt-4" v-else>
                        <v-row>
                          <v-col cols="2" class="titles-small pa-0 pr-4 text-right">Settings</v-col>
                          <v-col
                            @click="routeToStrategy"
                            cols="10"
                            class="titles-small pa-0 text-white text-left record-body pointer"
                          >
                            <b>{{data._prepare._strategy.name}}</b> |
                            <span :class="data._prepare.tradeType == 'Long' ? 'up' : 'down'">
                              <b>{{data._prepare.tradeType}}</b>
                            </span>
                            <v-btn
                              class="ml-2 bold pointer"
                              color="#79C04D"
                              x-small
                              rounded
                            >{{prepareTime}} before trade</v-btn>
                          </v-col>
                        </v-row>

                        <div class="pt-4">
                          <v-row>
                            <v-col cols="2" class="titles-small pa-0 pr-4 text-right">Checklist</v-col>
                            <v-col
                              cols="10"
                              class="titles-small pa-0 text-white text-left record-body"
                            >
                              <v-chip
                                @click="routeToTag(check._master)"
                                small
                                v-for="check in data._prepare.checklist"
                                :key="check._id"
                                :color="check.selected ? '#4dbac0' : '' "
                                class="float-left mr-2 mb-1"
                              >
                                <v-avatar left>
                                  <v-icon size="18" v-if="check.selected">check_box</v-icon>
                                  <v-icon size="18" v-else>check_box_outline_blank</v-icon>
                                </v-avatar>
                                {{check.name}}
                              </v-chip>
                            </v-col>
                          </v-row>
                        </div>
                        <div class="pt-4">
                          <v-row>
                            <v-col
                              cols="2"
                              class="titles-small pa-0 pr-4 text-right"
                            >Additional Tags</v-col>
                            <v-col
                              cols="10"
                              class="titles-small pa-0 text-white text-left record-body"
                            >
                              <v-chip
                                small
                                v-for="check in data._prepare.tags"
                                :key="check._id"
                                color="#4dbac0"
                                class="float-left mr-2 mb-1"
                              >
                                <v-avatar left>
                                  <v-icon size="18">check_box</v-icon>
                                </v-avatar>
                                {{check.name}}
                              </v-chip>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" class="pa-1 border-top">
                <div class="px-4">
                  <div class="width-full float-left pa-2 mb-2">
                    <span class style="font-size:12px; color: #e75480">
                      <v-icon size="18" class="mr-1" color="#e75480">backspace</v-icon>
                      <b>Post Evaluation</b>
                      <div class="pt-4">
                        <v-row>
                         
                          
                          <v-col cols="2" class="titles-small pa-0 pr-4 text-right">Strategy</v-col>
                          <v-col
                            cols="3"
                            class="titles-small pa-0 text-white text-left record-body"
                          >
                            <div class="strategyselector">
                              <v-select
                                :disabled="!myOwn"
                                v-model="selectedStrategy"
                                placeholder="* Strategy"
                                :items="userStrategies"
                                itemText="name"
                                background-color="#404855"
                                return-object
                                solo
                                flat
                              ></v-select>
                            </div>
                          </v-col>
                          <v-col cols="12" class="mt-2"></v-col>

                           <v-col cols="2" class="titles-small pa-0 pr-4 text-right">Tags</v-col>
                          <v-col
                            cols="10"
                            class="titles-small pa-0 text-white text-left record-body"
                          >
                            <v-chip
                              small
                              v-for="(check,index) in tags"
                              :key="check._id"
                              :color="check.selected ? '#e75480' : '' "
                              class="float-left mr-2 pointer mb-1"
                              @click="updateTags(check,index)"
                            >
                              <v-avatar left>
                                <v-icon size="18" v-if="check.selected">check_box</v-icon>
                                <v-icon size="18" v-else>check_box_outline_blank</v-icon>
                              </v-avatar>
                              {{check.name}}
                            </v-chip>
                          </v-col>
                        </v-row>
                      </div>
                    </span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
          <v-card flat class="pa-4 mt-4">
            <div class="chart-title-new">Trade Comments</div>
            <div class="mt-4">
              <InputBox parentType="Trades" :parentId="$route.params.id" subtype="Trade comment" />

              <transition-group name="list">
                <div
                  class="record-card"
                  v-for="record in data._timeline"
                  :key="record.created"
                  @click="routeTo(record)"
                  :style="record._id == $route.params.message ? 'background-color: #474e59 !important' : ''"
                >
                  <TradeComment :record="record" />
                  <div v-if="record._images" class="width-full float-left pt-1 pl-5">
                    <vue-picture-swipe small :items="record._images"></vue-picture-swipe>
                  </div>
                </div>
              </transition-group>
            </div>
          </v-card>
        </v-col>

        <v-col xl="3" lg="3" md="3" sm="12" class="px-2">
          <v-card flat>
            <TradeData :data="data" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <div class="width-full" style="text-align:center;margin-top: 120px" v-else>
      <v-progress-circular :size="100" :width="7" color="#4dbac0" indeterminate>
        <div class="text-center">
          <div>
            <img class="brand-img" width="50" src="https://tradeinpool.com/img/logo.svg" />
          </div>
          <div>loading...</div>
        </div>
      </v-progress-circular>
    </div>
  </div>
</template>

<script>
var moment = require("moment-timezone");
import Chart from "@/components/ChartNew/";
import VuePictureSwipe from "vue-picture-swipe";
import TextSlicer from "@/components/textSlicer.vue";
import { mapGetters } from "vuex";
import TextInput from "@/components/textInputBig.vue";
import TradeComment from "@/components/PoolTimeline/message.vue";
import UploadBox from "@/components/uploadBox.vue";
import TradeData from "./tradeData.vue";
import axios from "axios";
import Avatar from "vue-avatar";
import InputBox from "@/components/textInput.vue";
export default {
  name: "DiaryDetail",
  components: {
    TradeComment,
    InputBox,
    TradeData,
    TextSlicer,
    Avatar,
    VuePictureSwipe,
    TextInput,
    Chart,
    UploadBox
  },
  data() {
    return {
      selectedStrategy: null,
      tagChange: true,
      zones: [],
      uploading: false,
      mainImg: false,
      description: null,
      editDesc: false,
      sendingDescription: false,
      descriptionInputReset: new Date(),
      msgSelected: false,
      textInputReset: new Date(),
      myOwn: false,
      loaded: false,
      user: null,
      data: null,
      stats: {},
      newItem: {
        images: [],
        description: null
      },
      detailDateRout: null,
      detailDateString: null,
      prepareTime: null,
      tags: []
    };
  },
  computed: {
    ...mapGetters(["timezone", "username"]),
    diaryTime() {
      return moment.tz(this.data.createdAt, this.timezone).format("hh:mm");
    }
  },

  asyncComputed: {
    userStrategies: {
      get() {
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3001/api/request/strategies/", {
              method: "listBasic",
              user: this.$route.params.name
            })
            .then(response => {
              resolve(response.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      default: []
    }
  },
  watch: {
    selectedStrategy(newVal) {
      this.updateStrategy(newVal);
    }
  },
  methods: {
    updateTags(chck, idx) {
      if (this.myOwn && this.tagChange) {
        this.tagChange = false;

        var action = "add";

        var oldobj = this.tags[idx];
        if (oldobj.selected) {
          oldobj.selected = false;
          action = "remove";
        } else {
          oldobj.selected = true;
        }

        axios
          .post("https://tradeinpool.com:3001/api/update/tradetags/", {
            action: action,
            value: chck._id,
            tradeid: this.data._id,
            active: this.data.active,
            openTimestamp: this.data.openTimestamp
          })
          .then(() => {
            //alert("done")
            this.tagChange = true;
            this.$set(this.tags, idx, oldobj);
          });
      }
    },
    updateStrategy(chck) {
      axios
        .post("https://tradeinpool.com:3001/api/update/tradestrategy/", {
          value: chck._id,
          tradeid: this.data._id,
          active: this.data.active,
          openTimestamp: this.data.openTimestamp
        })
        .then(() => {});
    },

    deleteImg() {
      this.mainImg = false;
    },
    editDescription() {
      this.description = this.data.Description;
      this.editDesc = true;
    },
    resetData() {
      this.textInputReset = new Date();
      this.newItem = {
        images: [],
        description: null
      };
    },
    resetDescription() {
      this.descriptionInputReset = new Date();
      this.description = null;
    },
    routeToDiary() {
      this.$router.push({
        name: "Diary",
        params: { name: this.$route.params.name }
      });
    },
    routeToStrategy() {
      return this.$router.push({
        name: "strategies",
        params: {
          name: this.$route.params.name,
          id: this.data._prepare._strategy._id
        }
      });
    },
    routeToTag(id) {
      return this.$router.push({
        name: "tags",
        params: { name: this.$route.params.name, id: id }
      });
    },
    routeToDiaryDate() {
      this.$router.push({
        name: "Diary",
        params: { name: this.$route.params.name, date: this.detailDateRout }
      });
    },
    routeUser() {
      this.$router.push({
        name: "user",
        params: { name: this.$route.params.name }
      });
    },
    setData(data) {
      this.detailDateRout = moment(data.createdAt).format("YYYY-MM-DD");
      (this.detailDateString = moment(this.$route.params.date).format(
        "dddd LL"
      )),
        (this.loaded = true);
      this.data = data;

      this.selectedStrategy = data._strategies;

      if (data) {
        this.getZones();
      }

      this.getTags();
      if (this.data._mainImg) {
        this.mainImg = true;
      }
      if (this.data._prepare) {
        this.prepareTime = moment.duration(
          moment(this.data.openTimestamp).diff(
            moment(this.data._prepare.startedAt)
          )
        ); // 86400000
      }
    },
    sendMessage() {
      if (this.newItem.description || this.newItem.images.length > 0) {
        //this.$emit("loading", true);
        // requred fields check
        this.sending = true;
        // prepare api data
        let formData = new FormData();
        formData.append("parentType", "Diary");
        formData.append("_parentId", this.data._id);
        formData.append("description", this.newItem.description);
        formData.append("urlDate", this.$route.params.date);
        formData.append("subtype", "Idea comment");
        this.newItem.images.forEach(fileItem => {
          formData.append("img", fileItem);
        });

        axios
          .post("https://tradeinpool.com:3001/api/add/message/", formData)
          .then(() => {
            this.resetData();
            //var thiis = this;
            this.sending = false;
            this.flash("Idea comment send", "success", {
              timeout: 2000
            });
            setTimeout(() => {
              //this.$emit("loading", false);
            }, 1000);
          });
      }
    },

    uploadImage(data) {
      //this.$emit("loading", true);
      // requred fields check
      this.uploading = true;
      // prepare api data
      let formData = new FormData();
      formData.append("parentType", "Trade");
      formData.append("_parentId", this.data._id);
      formData.append("urlDate", this.$route.params.id);
      formData.append("subtype", "Trade Image");
      formData.append("img", data);

      axios
        .post("https://tradeinpool.com:3001/api/add/img/", formData)
        .then(response => {
          //this.resetDataUpload();
          //var thiis = this;
          this.uploading = false;
          this.data._mainImg = response.data;
          this.mainImg = true;
          this.flash("Display image uploaded", "success", {
            timeout: 2000
          });
        });
    },
    saveDescription() {
      //this.$emit("loading", true);
      // requred fields check
      this.sendingDescription = true;
      // prepare api data
      /*
      let formData = new FormData();
      formData.append("parentType", "Trade");
      formData.append("_parentId", this.data._id);
      formData.append("urlDate", this.$route.params.id);
      formData.append("subtype", "Trade Description");
      formData.append("description", this.description);
      */
      let formData = {
        parentType: "Trade",
        _parentId: this.data._id,
        urlDate: this.$route.params.id,
        subtype: "Trade Description",
        description: this.description
      };

      axios
        .post("https://tradeinpool.com:3001/api/add/description/", formData)
        .then(response => {
          this.data.Description = response.data;
          this.sendingDescription = false;
          this.editDesc = false;
          this.resetDescription();
          this.flash("Trade description saved", "success", {
            timeout: 2000
          });
        });
    },

    imgData(data) {
      this.newItem.images = data;
    },
    textData(data) {
      this.newItem.description = data;
    },
    descriptionData(data) {
      this.description = data;
    },
    imgDataDisplay(data) {
      this.uploadImage(data);
    },

    getDetail() {
      axios
        .post("https://tradeinpool.com:3001/api/request/trades/", {
          method: "detail",
          user: this.$route.params.name,
          id: this.$route.params.id
        })
        .then(response => {
          this.setData(response.data);
        });
    },

    getZones() {
      axios
        .post("https://tradeinpool.com:3001/api/request/levels/", {
          method: "chart",
          date: this.data.openTimestamp,
          ticker: this.data.Symbol.user,
          user: this.$route.params.name
        })
        .then(response => {
          this.zones = response.data;
          //alert("zones")
        });
    },

    getUser() {
      axios
        .post("https://tradeinpool.com:3001/api/request/user/", {
          method: "basic",
          name: this.$route.params.name
        })
        .then(response => {
          this.user = response.data;
        });
    },
    setTags(data) {
      data.forEach((tag, index) => {
        this.tags.push(tag);

        var selected = false;

        if (this.data._prepare) {
          /*
          if (this.data._prepare.checklist) {
            this.data._prepare.checklist.forEach(check => {
              if (tag.name == check.name && check.selected) {
                selected = true;
              }
            });
          }

          if (this.data._prepare.tags) {
            this.data._prepare.tags.forEach(check => {
              if (tag.name == check.name) {
                selected = true;
              }
            });
          }
          */
        }

        //if (this.data.Tags) {
        this.data._tags.forEach(check => {
          if (tag._id == check) {
            selected = true;
          }
        });
        //}

        this.tags[index].selected = selected;
      });
    },
    getTags() {
      axios
        .post("https://tradeinpool.com:3001/api/request/Tags/", {
          method: "listBasic",
          user: this.$route.params.name
        })
        .then(response => {
          this.setTags(response.data);
        });
    },
    liveUpdate(data) {
      //alert(data.data.MarketData)
      this.data.OpenProfitLoss = data.data.OpenProfitLoss;
      if (this.data.Fills != data.data.Fills) this.data.Fills = data.data.Fills;
      this.data.OpenProfitLoss = data.data.OpenProfitLoss;
      this.data.LastPrice = data.data.LastPrice;
      if (data.data.FlatToFlatMaximumOpenPositionLoss != 0)
        this.data.FlatToFlatMaximumOpenPositionLoss =
          data.data.FlatToFlatMaximumOpenPositionLoss;
      if (data.data.FlatToFlatMaximumOpenPositionProfit != 0)
        this.data.FlatToFlatMaximumOpenPositionProfit =
          data.data.FlatToFlatMaximumOpenPositionProfit;
      this.data.active = data.active;
      this.data.Quantity = data.data.Quantity;
      if (this.data.MarketData.length == 0) {
        this.data.MarketData.push(data.data.MarketData);
      } else if (
        data.data.MarketData.time >
        this.data.MarketData[this.data.MarketData.length - 1].time
      ) {
        this.data.MarketData.push(data.data.MarketData);
      }
    }
  },
  created() {
    if (this.$route.params.name == this.username) {
      this.myOwn = true;
    } else {
      this.myOwn = false;
      this.getUser();
    }

    this.getDetail();
  },

  mounted() {
    //if (this.$route.params.message == this.record._id) {
    this.scrollToId();
    //setTimeout(() => {
    //this.$vuetify.goTo(this.$route.params.message, { offset: 0 });
    //}, 2000);
    // }
  },
  sockets: {
    TIMELINE: function(data) {
      if (data.user.username == this.$route.params.name) {
        if (data.type == "Trade Open") {
          if (data.data.openTimestamp == this.$route.params.id) {
            this.liveUpdate(data);
          }
        }
      }

      if (data.subtype == "Trade comment") {
        if (data.urlDate == this.$route.params.id) {
          this.data._timeline.unshift(data);
        }
      }
    }
  }
};
</script>

<style scoped>
.date-picker {
  z-index: 50;
  position: absolute;
}
.border-left {
  border-left: 1px solid #1e242e;
}
.border-top {
  border-top: 1px solid #1e242e;
}
</style>